
import React from 'react';

const WhySection: React.FC = () => {
  const benefits = [
    {
      title: 'Selbstvertrauen im Notfall',
      desc: 'Wissen reduziert Panik. Wir trainieren dein Unterbewusstsein, damit du im Ernstfall automatisch das Richtige tust.',
      icon: '🛡️',
      color: 'bg-primary/10 text-primary'
    },
    {
      title: 'Wissenschaftlich geprüft',
      desc: 'Kein gefährliches Halbwissen. Alle Inhalte folgen strikt den aktuellen ERC-Leitlinien und werden medizinisch validiert.',
      icon: '🔬',
      color: 'bg-secondary/10 text-secondary'
    },
    {
      title: 'Effizientes Mikrolernen',
      desc: 'Nur 5 Minuten am Tag reichen aus. Perfekt integriert in deinen Alltag, für maximalen Lernerfolg ohne Zeitdruck.',
      icon: '⚡',
      color: 'bg-amber-500/10 text-amber-600'
    },
    {
      title: 'Gesellschaftlicher Impact',
      desc: 'Mit jeder Lerneinheit trägst du dazu bei, Deutschland sicherer zu machen. Werde Teil einer wachsenden Retter-Community.',
      icon: '🌍',
      color: 'bg-green-500/10 text-green-600'
    }
  ];

  return (
    <div className="container mx-auto px-4 md:px-6">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-5xl font-extrabold text-secondary mb-8 leading-tight">
           Im Notfall zählt jede Sekunde – <br className="hidden md:block" /> <span className="text-primary italic">nicht Google.</span>
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto text-xl leading-relaxed">
           Theoretisches Wissen verblasst schnell. Wir sorgen dafür, dass deine Fähigkeiten präsent bleiben – damit du nicht nur zuschauen musst, sondern <span className="font-bold text-secondary">echte Hilfe leisten kannst.</span>
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {benefits.map((b, idx) => (
          <div key={idx} className="bg-white p-8 rounded-[2.5rem] shadow-sm border border-gray-100 hover:shadow-xl transition-all duo-card border-b-gray-100 group">
            <div className={`w-16 h-16 rounded-2xl flex items-center justify-center text-3xl mb-6 transition-transform group-hover:scale-110 ${b.color}`}>
              {b.icon}
            </div>
            <h3 className="text-xl font-bold text-secondary mb-3">{b.title}</h3>
            <p className="text-gray-500 leading-relaxed text-sm">
              {b.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhySection;
